import styled from 'styled-components';
import { popoverShadow } from '../../themes/shadows';

export const Box = styled.div`
  margin-left: 10px;
  top: 550px;
  background-color: ${(props) => props.theme.colors.card};
  box-shadow: ${popoverShadow};
  border-radius: 10px;
  width: 110px;
  height: 26px;
  align-items: center;
  justify-content: center;
  display: flex;
  position: fixed;
  flex-direction: column;
`;
